import axios from 'axios';
import mycolor from '@/mycolor.js';

export default {
  created() {
      console.log('%c %s', mycolor.created, 'created: mixin.js');
  },
  mounted() {
  },
  methods: {
        setToken() {
              // 毎回トークンを送ってもらうようにする.
              let user = JSON.parse(localStorage.getItem('user'));
              let access_token = '';
              if(user!==null){
                  access_token = user.access_token;
              }
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
        },

        setBlob(){
            // .csvをダウンロードできるように headerを作る
            axios.defaults.headers.common['responseType'] = 'blob';
        },

        // 通知を取得
        getNotice(){
            console.log('%c getNotice()', mycolor.strong);

            this.setToken();
            axios.get('/get_notice').then( (res) =>{
                console.group();
                console.log('%c /get_notice', mycolor.api);
                console.log(res.data);
                console.groupEnd();

                this.$store.dispatch( 'notices', res.data );

            })
            .catch( () => {
                if( this.$route.name!='login' ){
                    alert('トークンが有効期限切れです.ログインし直してください.');
                }
                console.log('logout()');
                localStorage.clear('user');
                this.$store.dispatch( 'user', null );
                this.$store.dispatch( 'notices', [] );
                this.$router.push( { name:'login', query:{from: this.$route.name} } ).catch(()=>{});
            });
        },


        readNotice(){

              console.log( '%c readNotice()', mycolor.created );

              // login_userの通知を既読にする
              this.setToken();
              axios.post('/read_notice')
              .then((res) => {
                  console.group();
                  console.log('%c %s', mycolor.api, '/read_notice');
                  console.log(res.data);
                  console.groupEnd();

                  // 新しい通知がないか確認
                  this.getNotice();
              })
              .catch( e => { console.log(e) } );
        },

  }
}

